import React, { useRef } from 'react'
import { OrbitControls, useGLTF } from '@react-three/drei'

import { useTexture } from '@react-three/drei'
import { Canvas, useFrame } from '@react-three/fiber'

const Object = (...props) => {

  const group = useRef()
  const { nodes, materials } = useGLTF('/3DObjects/Macbook/macbook.glb')
  const [baseMap,metallicMap,normalMap,emmisiveMap] = useTexture(['/3DObjects/Macbook/MacBookPro_baseColor.jpeg','/3DObjects/Macbook/MacBookPro_metallicRoughness.png','/3DObjects/Macbook/MacBookPro_normal.png','/3DObjects/Macbook/MacBookPro_emissive.jpeg'])
  const macbookRef = useRef();
  useFrame(()=>{
    macbookRef.current.rotation.y = macbookRef.current.rotation.y + 0.01
  })
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh geometry={nodes.Ecran.geometry} rotation={[0.3,1.5,0]}  position={[0.12, 0.01,0]} scale={7} ref={macbookRef}>
      <meshPhongMaterial  map={baseMap} specularMap={metallicMap} shininess={30} depthWrite={true} />
      </mesh>
    </group>
  )
}
useGLTF.preload('/s.glb')



const Macbook = () => {
  return (
      <Canvas>
          <ambientLight intensity={2}/>
          <Object/>
    </Canvas>
  )
}

export default Macbook